import find from 'lodash/find';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

import { Optional } from 'chaika-common-types';

import { removeNotNumbers } from '@utils/removeNotNumbers';

import { phoneCodes } from '../phone-codes';

interface PhoneCodeParams {
    countryCode: string;
    phoneMask: string;
}

interface PhoneParams extends PhoneCodeParams {
    currentValue: string;
}

export function getPhoneParams(value: string): PhoneParams {
    const parsedPhone = parsePhoneNumberFromString(/^\+/.test(value) ? value : `+${value}`);

    const currentValue = parsedPhone ? parsedPhone.number.replace('+', '') : '';

    return {
        currentValue,
        ...getPhoneCodeParams(value),
    };
}

export function getPhoneCodeParams(value: string): PhoneCodeParams {
    const parsedPhone = parsePhoneNumberFromString(/^\+/.test(value) ? value : `+${value}`);

    const countryCode = (parsedPhone && parsedPhone.country) || '';
    const phoneMask = parsedPhone ? getMask(parsedPhone.country, value) : '';

    return { countryCode, phoneMask };
}

export function getMask(locale: Optional<string>, value: string): string {
    const digitValue = removeNotNumbers(value);
    const phoneCode = find(
        phoneCodes,
        phoneCode => phoneCode.cc === locale && digitValue.startsWith(removeNotNumbers(phoneCode.mask)),
    );

    return phoneCode ? phoneCode.mask : '';
}
